import { TypePolicies } from "@apollo/client";

import {
  Maybe,
  ModuleRepositoryMetadata,
  SpaceliftMetrics,
  StackIntegrations,
  UserGuideMetadata,
  UserGuideProgress,
  Version,
} from "types/generated";

const TYPE_POLICIES: TypePolicies = {
  Query: {
    fields: {
      searchVCSIntegrations: {
        keyArgs: ["input"],
      },
      metrics: {
        merge(existing: Maybe<SpaceliftMetrics>, incoming: Maybe<SpaceliftMetrics>) {
          return { ...existing, ...incoming };
        },
      },
      metricsRange: {
        merge(existing: Maybe<SpaceliftMetrics>, incoming: Maybe<SpaceliftMetrics>) {
          return { ...existing, ...incoming };
        },
        keyArgs: false,
      },
      activeUserGuideProgress: {
        merge(existing: Maybe<UserGuideProgress>, incoming: Maybe<UserGuideProgress>) {
          if (!incoming) return incoming;
          return { ...existing, ...incoming };
        },
      },
      completedUserGuides: {
        merge: false,
      },
    },
  },
  AuditTrailWebhook: {
    keyFields: ["endpoint"],
  },
  ConfigElement: {
    keyFields: ["id", "type"],
  },
  Stack: {
    fields: {
      integrations: {
        merge(existing: StackIntegrations, incoming: StackIntegrations) {
          return { ...existing, ...incoming };
        },
      },
    },
  },
  Module: {
    fields: {
      versions: {
        keyArgs: ["includeFailed"],
        merge(existing: Map<string, Version>, incoming: Version[], { readField }) {
          const merged = new Map<string, Version>(existing);

          for (const item of incoming) {
            const id = readField<string>("id", item);

            if (id) {
              merged.set(id, item);
            }
          }

          return merged;
        },
        read(existing: Map<string, Version>) {
          return existing && Array.from(existing.values());
        },
      },
    },
  },
  Version: {
    fields: {
      metadata: {
        merge(existing: ModuleRepositoryMetadata, incoming: ModuleRepositoryMetadata) {
          return { ...existing, ...incoming };
        },
      },
    },
  },
  Repository: {
    keyFields: ["name", "namespace"],
  },
  BlueprintInput: {
    keyFields: false,
  },
  VCSIntegration: {
    keyFields: ["id", "provider"],
  },
  SpaceliftMetrics: {
    keyFields: false,
  },
  Space: {
    keyFields: false,
  },
  UserGuide: {
    fields: {
      metadata: {
        merge(existing: UserGuideMetadata, incoming: UserGuideMetadata) {
          return { ...existing, ...incoming };
        },
      },
    },
  },
};

export default TYPE_POLICIES;
